var _rect, _rect2, _path, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1200,
    height: 600,
    viewBox: "0 0 5376 2688",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    width: 5376,
    height: 2688
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "#00356a",
    y: 896,
    width: 5376,
    height: 896
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#dc241f",
    strokeWidth: 128,
    d: "M0,192h5376 M0,448h5376 M0,704h5376 M0,1984h5376 M0,2240h5376 M0,2496h5376"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd100",
    d: "m 1343.8751,1063.9999 24.9666,170.8001 96.6001,-143.0334 -51.8,164.7333 149.1,-87.0332 -118.0666,126 172.1998,-13.7668 -161,62.3 161,62.3 -172.1998,-13.7665 118.0666,126 -149.1,-87.0333 51.8,164.7331 -96.6001,-143.0332 -24.9666,170.7998 -24.9666,-170.7998 -96.6,143.0332 51.7999,-164.7331 -149.0999,87.0333 118.0666,-126 -172.2002,13.7665 161,-62.3 -161,-62.3 172.2002,13.7668 -118.0666,-126 149.0999,87.0332 -51.7999,-164.7333 96.6,143.0334 z M 1203.875,1071 a 298.66667,298.66667 0 1 0 0,546 336,336 0 1 1 0,-546 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKl);
export default __webpack_public_path__ + "static/media/kl.29a85a2df4f27683b51538f8bd275269.svg";
export { ForwardRef as ReactComponent };